// tslint:disable
export enum ProgramUsageType {
    /**
     * @description Hub
     */
    Hub = 1,
    /**
     * @description Copay
     */
    Copay = 2,
    /**
     * @description Patient Assitance Program
     */
    PatientAssitanceProgram = 3,
    /**
     * @description Clinical Trial
     */
    ClinicalTrial = 4,
}
(ProgramUsageType as any)['HUB'] = 1;
(ProgramUsageType as any)['COPAY'] = 2;
(ProgramUsageType as any)['PATIENTASSITANCEPROGRAM'] = 3;
(ProgramUsageType as any)['CLINICALTRIAL'] = 4;
